/* import __COLOCATED_TEMPLATE__ from './html-editor.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { isBlank, isEmpty } from '@ember/utils';
/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { ref } from 'ember-ref-bucket';
let HtmlEditor = (_dec = ref('textarea'), (_class = class HtmlEditor extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "textarea", _descriptor, this);
    _initializerDefineProperty(this, "content", _descriptor2, this);
  }
  get isSaveDisabled() {
    return isEmpty(this.content) || isBlank(this.content);
  }
  saveBlock() {
    let block = {
      type: 'html',
      content: this.textarea?.value
    };
    let {
      commands
    } = this.args.composer;
    if (this.args.htmlBlock) {
      commands.updateSelectedNode(block);
    } else {
      this.args.insertBlock(block);
    }
    this.args.onClose();
  }
  deleteThisBlock() {
    this.args.composer.commands.deleteSelection();
    this.args.onClose();
  }
  getTextAfterTemplateInsertionAtCursorPosition(textarea, attributeTemplate, cursorPosition) {
    return textarea.value.substring(0, cursorPosition) + attributeTemplate + textarea.value.substr(cursorPosition);
  }
  selectTemplateFallBackText(textarea, cursorPosition, attributeTemplateStartPosition, attributeTemplateEndPosition) {
    let targetStartPosition = cursorPosition + attributeTemplateStartPosition;
    let targetEndPosition = cursorPosition + attributeTemplateEndPosition;
    textarea.focus();
    textarea.setSelectionRange(targetStartPosition, targetEndPosition);
  }
  onInsert(attributeTemplate, attributeTemplateStartPosition = 0, attributeTemplateEndPosition = 0) {
    this.args.composer.config.analytics?.trackAnalyticsEvent('inserted', {
      block_type: 'html'
    });
    if (this.textarea) {
      let cursorPosition = this.textarea.selectionStart || this.textarea.value.length;
      this.textarea.value = this.getTextAfterTemplateInsertionAtCursorPosition(this.textarea, attributeTemplate, cursorPosition);
      this.selectTemplateFallBackText(this.textarea, cursorPosition, attributeTemplateStartPosition, attributeTemplateEndPosition);
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "textarea", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "content", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.htmlBlock?.content || '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "saveBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "saveBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteThisBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteThisBlock"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInsert"), _class.prototype)), _class));
export { HtmlEditor as default };